<template>
  <div class="Aboutus">
    <div class="about-bannerbox">
      <div class="about-bannerbox-content">
        <p class="bannerbox-contentname">关于我们</p>
        <p class="bannerbox-contenttext">
          我想成为一个追求社会和人力资源可持续发展的探索者， 这样即使100年之后，这种爱也可以实现。
        </p>
      </div>
    </div>
    <!-- banner end -->
    <!-- newsitem strat -->
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <p class="aboutus-title-english">NOW YOU SEE</p>
        <p class="aboutus-title">即刻优势</p>
        <p class="green-title-aboutus">互联网+教育 Internet+ Education</p>
        <p class="label-aboutus">专业高效 让互联网推动教育行业创新发展</p>
        <article class="aboutus-article" v-for="(item, index) in articlelist" :key='item.index'>{{item.article}}</article>
      </el-col>
    </el-row>
    <!-- newsitem end -->
    <!-- bntbox start -->
    <div class="bnt-box">
      <el-button plain round class="bnt-team" @click="SelectContact()">点击这里，开启我们的合作之门！</el-button>
    </div>
    <!-- bntbox end -->
    <!-- 底部引入 -->
    <FooderContent></FooderContent>
  </div>
  </div>
</template>

<script>
  import BannerImage from '../components/Bannar.vue'
  import FooderContent from '../components/fooder.vue'
  export default {
    components: {
      BannerImage,
      FooderContent
    },
    methods:{
      /* 联系我们 */
      SelectContact() {
      	this.$router.push({
      		path: '/Contactus#dwon'
      	})
      }
    },
    data() {
      return {
        articlelist: [{
            id: '01',
            article: '深圳即刻优势教育科技有限公司，是一家专注于为教育行业的各类学机构和公司提供全方位的教育解决方案的创新型企业。经过多年的发展和沉淀，公司已经在教育行业取得良好的口碑及成熟的服务经验，已经为各大中小学、教育机构和行业服务公司提供多种服务产品和解决方案。公司将以为传统教育行业打造IT科技服务为起点，包括为传统教育行业提供IT外包服务，包括在线教育管理，在线分销系统，在线直播，家校等多方互联和智慧校园整体式解决方案，教育经营服务方案以及IT行业培训方案。'
          },
          {
            id: '02',
            article: ' 受2020年的疫情影响，传统教育行业中的大小企业已经深深意识到教育互联网化的重要性，随之到来的5G物联网发展，教育线上直播和视频必将更加成熟。家长和学生在疫情期间逐渐接受网络远程教育的观念，这一切必将加速线上教育的发展。未来远程授课，线上课程，线上家校管理一定是一大发展趋势。在现有的教育机构大多数还是传统教育的背景之下，无论政府还是企业本身都必将成为云教育的催化剂。线上教育在未来几十年，将会占有千亿级的市场，提供教育解决方案也会面临巨大的市场和红'
          },
          {
            id: '03',
            article: ' 即刻优势作为深圳青葵教育与上海邻米科技联合打造的教育领域业务开拓全资子公司，将继承双方多年沉淀的资源，目标在未来发展成为一家可以为教育行业客户提供全套教育解决方案的专业综合服务型解决公司。'
          },
        ]
      }
    },
    created() {
      console.log(this.articlelist, 11111)
    },
  }
</script>

<style>
  /* banner start */
  .about-bannerbox {
  	width: 100%;
  	min-width: 118rem;
  	height: 29.1875rem;
  	background-image: url(../assets/news-image/aboutbanner.jpg);
  	background-size: 100% 100%
  }

  .about-bannerbox-content {
  	width: 21.875rem;
  	overflow: auto;
  	padding-top: 13.6875rem;
  	padding-left: 22.5rem
  }

  .bannerbox-contentname {
  	font-size: 1.875rem;
  	font-family: Source Han Sans SC;
  	color: #fff;
  	margin-bottom: 1.5rem
  }

  .bannerbox-contenttext {
  	font-size: 0.875rem;
  	font-family: Source Han Sans SC;
  	font-weight: 400;
  	color: #fff;
  	opacity: 1;
  	margin: 0
  }

  /* banner end */
  /* newsitem strat */
  .aboutus-title-english {
  	margin-bottom: .375rem;
  	margin-top: 5.5625rem
  }

  .aboutus-title,
  .aboutus-title-english {
  	font-size: 1.875rem;
  	font-family: Microsoft YaHei;
  	color: #444;
  	text-align: center
  }

  .aboutus-title {
  	margin-top: 0;
  	margin-bottom: 5rem
  }

  .green-title-aboutus {
  	font-size: .8rem;
  	font-family: Source Han Sans SC;
  	line-height: 1.6875rem;
  	color: #39ab6d;
  	text-align: center;
  	margin-bottom: 1.5rem
  }

  .label-aboutus {
  	text-align: center;
  	margin-bottom: 6.25rem !important
  }

  .aboutus-article {
  	margin: 4.0625rem auto;
  	width: 60%;
  	text-indent: 2em;
  	overflow: auto;
  	text-align: center;
  	font-size: 1.125rem;
  	color: #333;
  	font-family: Source Han Sans SC
  }

  .Aboutus .el-col .aboutus-article :hover {
  	-webkit-transform: scale(1.1);
  	transform: scale(1.1);
  	-webkit-transition: -webkit-transform .6s;
  	transition: -webkit-transform .6s;
  	transition: transform .6s;
  	transition: transform .6s, -webkit-transform .6s
  }

  /* newsitem end */
  /* bntbox start */
  .bnt-box {
  	width: 100%;
  	overflow: auto;
  	text-align: center;
  	margin-bottom: 150px;
  	margin-top: 113px
  }

  .bnt-team {
  	width: 18.75rem;
  	margin: 5rem auto
  }

  @media screen and (max-width: 100rem) {

    /* banner start */
    .about-bannerbox {
    	width: 100%;
    	min-width: 118rem;
    	height: 30rem !important;
    	background-image: url(../assets/news-image/aboutbanner.jpg);
    	background-size: 100% 100%
    }

    .about-bannerbox-content {
    	width: 23rem !important;
    	overflow: auto;
    	padding-top: 14.3rem !important;
    	padding-left: 20rem !important
    }

    .bannerbox-contentname {
    	font-size: 2rem;
    	margin-bottom: 1.5rem;
    	font-family: Source Han Sans SC;
    	color: #fff
    }

    .bannerbox-contenttext {
    	font-size: .9rem;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	color: #fff;
    	opacity: 1
    }

    .Aboutus .el-row,
    .bnt-box {
    	width: 100%;
    	min-width: 110rem
    }

    .bnt-box {
    	overflow: auto;
    	text-align: center;
    	margin-bottom: 150px;
    	margin-top: 113px
    }

    /* banner end */
  }

  @media screen and (max-width: 62rem) {

    /* banner start */
    .about-bannerbox {
    	width: 100%;
    	min-width: 100%;
    	height: 13rem !important;
    	background-image: url(../assets/news-image/aboutbanner.jpg);
    	background-size: 100% 100%
    }

    .about-bannerbox-content {
    	width: 19rem !important;
    	overflow: auto;
    	padding-top: 6rem !important;
    	padding-left: 10rem !important
    }

    .bannerbox-contentname {
    	font-size: 1rem;
    	margin-bottom: 1rem;
    	font-family: Source Han Sans SC;
    	color: #fff
    }

    .bannerbox-contenttext {
    	font-size: .1rem;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	color: #fff;
    	opacity: 1
    }

    .Aboutus .el-row,
    .bnt-box {
    	width: 100%;
    	min-width: 100%
    }

    /* banner end */
  }

  /* bntbox end */
  /*  */
  @media screen and (max-width: 48rem) {

    /* banner start */
    .about-bannerbox {
    	width: 100%;
    	min-width: 100%;
    	height: 13rem !important;
    	background-image: url(../assets/news-image/aboutbanner.jpg);
    	background-size: 100% 100%
    }

    .about-bannerbox-content {
    	width: 75% !important;
    	min-width: 75%;
    	overflow: auto;
    	padding-top: 5rem !important;
    	padding-left: 3rem !important
    }

    .bannerbox-contentname {
    	font-size: 1rem;
    	margin-bottom: 1rem;
    	font-family: Source Han Sans SC;
    	color: #fff
    }

    .bannerbox-contenttext {
    	font-size: .1rem;
    	font-family: Source Han Sans SC;
    	font-weight: 400;
    	color: #fff;
    	opacity: 1
    }

    .bnt-box {
    	width: 100%;
    	min-width: 100%;
    	margin-bottom: 25%;
    	margin-top: 0
    }

    /* banner end */
  }
</style>



// WEBPACK FOOTER //
// src/views/Aboutus.vue